import ConfigurationsSidebar from 'components/ConfigurationsSidebar/ConfigurationsSidebar';
import PageLayout from 'components/PageLayout/PageLayout';
import React from 'react';
import { Outlet, useMatch } from 'react-router-dom';

const RouterPageLayout: React.FC = () => {
	const isNotHomeOrUnauthorized = useMatch('/configure/*');

	const showSidebar = !!isNotHomeOrUnauthorized;

	return (
		<PageLayout sidebarContent={showSidebar ? <ConfigurationsSidebar /> : null}>
			<Outlet />
		</PageLayout>
	);
};

export default RouterPageLayout;
